/**
 *
 * @author Matthew Rawson @ 02/05/2018 10:02
 * @description
 * @notes
 */
import React, {Fragment} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import locale from "@irati/utils/locale"
import {Strong, Para} from "@irati/ui/src/Labels"
import {isNextTriggerAtInThePast, tzAwareMoment, isScheduleEnabled} from "../../../helpers/schedule"


const SurveyDate = styled(Strong)`
  white-space: nowrap;
`

const NextTriggerAt = ({schedule, ...props}) => {
  const idNamespace = id("nextTriggerAt", props)
  const triggerInThePast = isNextTriggerAtInThePast(schedule)
  const tzAwareNextTriggerAt = tzAwareMoment(schedule, "nextTriggerAt")
  const scheduleIsEnabled = isScheduleEnabled(schedule)
  return (
    <Fragment>
      {scheduleIsEnabled && triggerInThePast && (
        <Para>
          <span id={id("past", idNamespace)}>Your most recent pulse survey was due to be sent out on </span>
          <SurveyDate>{tzAwareNextTriggerAt.format(locale.dates.longFormatWithDay)}.</SurveyDate>
        </Para>
      )}
      {scheduleIsEnabled && !triggerInThePast && (
        <Para>
          <span id={id("future", idNamespace)}>Your next pulse survey is scheduled to be sent out on </span>
          <SurveyDate>{tzAwareNextTriggerAt.format(locale.dates.longFormatWithDay)}.</SurveyDate>
        </Para>
      )}
      {!scheduleIsEnabled && (
        <Para id={id("paused", idNamespace)}>
          Your surveys have been <Strong>paused </Strong>and will not be sent until you resume
        </Para>
      )}
    </Fragment>
  )
}

NextTriggerAt.propTypes = {
  schedule: PropTypes.object
}
NextTriggerAt.defaultProps = {
  schedule: {}
}

export default NextTriggerAt
